import React from "react";
import Modal from "react-modal";
import { Button } from "@/components/Button/Button";

interface ConfirmAddToDoNotMailListModalProps {
  isOpen: boolean;
  isAdding: boolean;
  matchesCount: number;
  onClose: () => void;
  handleConfirm: () => void;
}

const ConfirmAddToDoNotMailListModal: React.FC<
  ConfirmAddToDoNotMailListModalProps
> = ({ isOpen, isAdding, onClose, handleConfirm, matchesCount }) => {
  return (
    <Modal
      className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-lg p-6 w-[calc(100%-32px)] max-w-[500px] bg-white dark:bg-slate-800 shadow-[0_10px_25px_rgba(0,0,0,.3)] outline-none overflow-y-auto"
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="fixed inset-0 bg-black/30 z-[9999]"
    >
      <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
        Add to Do Not Mail List
      </h3>
      <p className="mt-3 text-sm text-gray-600 dark:text-gray-400">
        Are you sure you want to add {matchesCount} new{" "}
        {matchesCount === 1 ? "address" : "addresses"} to the do not mail list?
      </p>

      <div className="mt-6 flex justify-end space-x-3">
        <Button disabled={false} onClick={onClose} variant="outline">
          Cancel
        </Button>
        <Button disabled={isAdding} onClick={handleConfirm}>
          {isAdding ? "Processing..." : "Confirm"}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmAddToDoNotMailListModal;
